import React from 'react';
import { Container, Typography, Box } from '@mui/material';
import Grid2 from '@mui/material/Grid2';
import { Trans } from 'react-i18next';

const PresenceSection = () => (
  <Container sx={{ py: 8, px: 4 }}>
    <Typography variant="h4" align="center" gutterBottom>
      <Trans i18nKey="presence.title">¿Dónde Estamos Presentes?</Trans>
    </Typography>
    {/* Mobile: 12 columnas (cada ítem ocupa 6 => 2 por fila)
        Desktop: 12 columnas (cada ítem ocupa 3 => 4 por fila) */}
    <Grid2 container spacing={4} columns={{ xs: 12, md: 12 }} mt={5}>
      
      {/* Uruguay */}
      <Grid2 size={{ xs: 6, md: 3 }} sx={{ textAlign: 'center' }}>
        <a
          href="https://mevuelo.com.uy"
          target="_blank"
          rel="noopener noreferrer"
          style={{ textDecoration: 'none', color: 'inherit' }}
        >
          <Box sx={{ position: 'relative', display: 'inline-block' }}>
            <img src="/uruguay-flag.svg" alt="Uruguay" style={{ width: '80%' }} />
          </Box>
          <Typography variant="body1" sx={{ mt: 2 }}><Trans i18nKey="presence.uy">Uruguay</Trans></Typography>
        </a>
      </Grid2>
      
      {/* Paraguay */}
      <Grid2 size={{ xs: 6, md: 3 }} sx={{ textAlign: 'center' }}>
        <a
          href="https://mevuelo.com.py"
          target="_blank"
          rel="noopener noreferrer"
          style={{ textDecoration: 'none', color: 'inherit' }}
        >
          <Box sx={{ position: 'relative', display: 'inline-block' }}>
            <img src="/paraguay-flag.svg" alt="Paraguay" style={{ width: '80%' }} />
          </Box>
          <Typography variant="body1" sx={{ mt: 2 }}><Trans i18nKey="presence.py">Paraguay</Trans></Typography>
        </a>
      </Grid2>
      
      {/* Bolivia */}
      <Grid2 size={{ xs: 6, md: 3 }} sx={{ textAlign: 'center' }}>
        <a
          href="https://mevuelo.com.bo"
          target="_blank"
          rel="noopener noreferrer"
          style={{ textDecoration: 'none', color: 'inherit' }}
        >
          <Box sx={{ position: 'relative', display: 'inline-block' }}>
            <img src="/bolivia-flag.svg" alt="Bolivia" style={{ width: '80%' }} />
          </Box>
          <Typography variant="body1" sx={{ mt: 2 }}><Trans i18nKey="presence.bo">Bolivia</Trans></Typography>
        </a>
      </Grid2>
      
      {/* Colombia */}
      <Grid2 size={{ xs: 6, md: 3 }} sx={{ textAlign: 'center' }}>
        <a
          href="https://mevuelo.com.co"
          target="_blank"
          rel="noopener noreferrer"
          style={{ textDecoration: 'none', color: 'inherit' }}
        >
          <Box sx={{ position: 'relative', display: 'inline-block' }}>
            <img src="/colombia-flag.svg" alt="Colombia" style={{ width: '80%' }} />
          </Box>
          <Typography variant="body1" sx={{ mt: 2 }}><Trans i18nKey="presence.co">Colombia</Trans></Typography>
        </a>
      </Grid2>
      
      {/* Estados Unidos */}
      <Grid2 size={{ xs: 6, md: 3 }} sx={{ textAlign: 'center' }}>
        <a
          href="https://mevuelo.us"
          target="_blank"
          rel="noopener noreferrer"
          style={{ textDecoration: 'none', color: 'inherit' }}
        >
          <Box sx={{ position: 'relative', display: 'inline-block' }}>
            <img src="/usa-flag.svg" alt="Estados Unidos" style={{ width: '80%' }} />
          </Box>
          <Typography variant="body1" sx={{ mt: 2 }}><Trans i18nKey="presence.us">Estados Unidos</Trans></Typography>
        </a>
      </Grid2>
      
      {/* España - con etiqueta "soon" */}
      <Grid2 size={{ xs: 6, md: 3 }} sx={{ textAlign: 'center' }}>
        <a
          href="https://mevuelo.com.es"
          target="_blank"
          rel="noopener noreferrer"
          style={{ textDecoration: 'none', color: 'inherit' }}
        >
          <Box sx={{ position: 'relative', display: 'inline-block' }}>
            <img src="/espana-flag.svg" alt="España" style={{ width: '80%' }} />
            <Box sx={{
              position: 'absolute',
              top: 4,
              right: 4,
              backgroundColor: 'rgba(0,0,0,0.7)',
              color: '#fff',
              px: 0.5,
              py: 0.25,
              fontSize: '0.6rem',
              borderRadius: 1
            }}>soon</Box>
          </Box>
          <Typography variant="body1" sx={{ mt: 2 }}><Trans i18nKey="presence.es">España</Trans></Typography>
        </a>
      </Grid2>
      
      {/* México - con etiqueta "soon" */}
      <Grid2 size={{ xs: 6, md: 3 }} sx={{ textAlign: 'center' }}>
        <a
          href="https://mevuelo.mx"
          target="_blank"
          rel="noopener noreferrer"
          style={{ textDecoration: 'none', color: 'inherit' }}
        >
          <Box sx={{ position: 'relative', display: 'inline-block' }}>
            <img src="/mexico-flag.svg" alt="México" style={{ width: '80%' }} />
            <Box sx={{
              position: 'absolute',
              top: 4,
              right: 4,
              backgroundColor: 'rgba(0,0,0,0.7)',
              color: '#fff',
              px: 0.5,
              py: 0.25,
              fontSize: '0.6rem',
              borderRadius: 1
            }}>soon</Box>
          </Box>
          <Typography variant="body1" sx={{ mt: 2 }}><Trans i18nKey="presence.mx">México</Trans></Typography>
        </a>
      </Grid2>
      
      {/* Brasil - con etiqueta "soon" */}
      <Grid2 size={{ xs: 6, md: 3 }} sx={{ textAlign: 'center' }}>
        <a
          href="https://voomeu.com/"
          target="_blank"
          rel="noopener noreferrer"
          style={{ textDecoration: 'none', color: 'inherit' }}
        >
          <Box sx={{ position: 'relative', display: 'inline-block' }}>
            <img src="/brazil-flag.svg" alt="Brasil" style={{ width: '80%' }} />
            <Box sx={{
              position: 'absolute',
              top: 4,
              right: 4,
              backgroundColor: 'rgba(0,0,0,0.7)',
              color: '#fff',
              px: 0.5,
              py: 0.25,
              fontSize: '0.6rem',
              borderRadius: 1
            }}>soon</Box>
          </Box>
          <Typography variant="body1" sx={{ mt: 2 }}><Trans i18nKey="presence.br">Brasil</Trans></Typography>
        </a>
      </Grid2>
      
      {/* Argentina - con etiqueta "soon" */}
      <Grid2 size={{ xs: 6, md: 3 }} sx={{ textAlign: 'center' }}>
        <a
          href="https://mevuelo.com.ar"
          target="_blank"
          rel="noopener noreferrer"
          style={{ textDecoration: 'none', color: 'inherit' }}
        >
          <Box sx={{ position: 'relative', display: 'inline-block' }}>
            <img src="/argentina-flag.svg" alt="Argentina" style={{ width: '80%' }} />
            <Box sx={{
              position: 'absolute',
              top: 4,
              right: 4,
              backgroundColor: 'rgba(0,0,0,0.7)',
              color: '#fff',
              px: 0.5,
              py: 0.25,
              fontSize: '0.6rem',
              borderRadius: 1
            }}>soon</Box>
          </Box>
          <Typography variant="body1" sx={{ mt: 2 }}><Trans i18nKey="presence.ar">Argentina</Trans></Typography>
        </a>
      </Grid2>
      
      {/* Chile - con etiqueta "soon" */}
      <Grid2 size={{ xs: 6, md: 3 }} sx={{ textAlign: 'center' }}>
        <a
          href="https://mevuelo.cl"
          target="_blank"
          rel="noopener noreferrer"
          style={{ textDecoration: 'none', color: 'inherit' }}
        >
          <Box sx={{ position: 'relative', display: 'inline-block' }}>
            <img src="/chile-flag.svg" alt="Chile" style={{ width: '80%' }} />
            <Box sx={{
              position: 'absolute',
              top: 4,
              right: 4,
              backgroundColor: 'rgba(0,0,0,0.7)',
              color: '#fff',
              px: 0.5,
              py: 0.25,
              fontSize: '0.6rem',
              borderRadius: 1
            }}>soon</Box>
          </Box>
          <Typography variant="body1" sx={{ mt: 2 }}><Trans i18nKey="presence.cl">Chile</Trans></Typography>
        </a>
      </Grid2>
      
      {/* Perú - con etiqueta "soon" */}
      <Grid2 size={{ xs: 6, md: 3 }} sx={{ textAlign: 'center' }}>
        <a
          href="https://mevuelo.com.pe"
          target="_blank"
          rel="noopener noreferrer"
          style={{ textDecoration: 'none', color: 'inherit' }}
        >
          <Box sx={{ position: 'relative', display: 'inline-block' }}>
            <img src="/peru-flag.svg" alt="Perú" style={{ width: '80%' }} />
            <Box sx={{
              position: 'absolute',
              top: 4,
              right: 4,
              backgroundColor: 'rgba(0,0,0,0.7)',
              color: '#fff',
              px: 0.5,
              py: 0.25,
              fontSize: '0.6rem',
              borderRadius: 1
            }}>soon</Box>
          </Box>
          <Typography variant="body1" sx={{ mt: 2 }}><Trans i18nKey="presence.pe">Perú</Trans></Typography>
        </a>
      </Grid2>
      
      {/* Italia - con etiqueta "soon" */}
      <Grid2 size={{ xs: 6, md: 3 }} sx={{ textAlign: 'center' }}>
        <a
          href="https://volamio.com"
          target="_blank"
          rel="noopener noreferrer"
          style={{ textDecoration: 'none', color: 'inherit' }}
        >
          <Box sx={{ position: 'relative', display: 'inline-block' }}>
            <img src="/italia-flag.svg" alt="Italia" style={{ width: '80%' }} />
            <Box sx={{
              position: 'absolute',
              top: 4,
              right: 4,
              backgroundColor: 'rgba(0,0,0,0.7)',
              color: '#fff',
              px: 0.5,
              py: 0.25,
              fontSize: '0.6rem',
              borderRadius: 1
            }}>soon</Box>
          </Box>
          <Typography variant="body1" sx={{ mt: 2 }}><Trans i18nKey="presence.it">Italia</Trans></Typography>
        </a>
      </Grid2>
    </Grid2>
  </Container>
);

export default PresenceSection;
